import {Injectable} from '@angular/core';
import {FilePicker, PickFilesResult} from '@capawesome/capacitor-file-picker';
import {FileSourceAsset} from '../../../Models/Shared/file-source-asset.interface';

@Injectable({
  providedIn: 'root'
})
export class FilePickerManagerService {

  /**
   * Obtener archivos desde el gestor de documentos
   *
   */
  public async getFileFromDevice(): Promise<FileSourceAsset[]> {
    const files: FileSourceAsset[] = [];
    const result: PickFilesResult = await FilePicker.pickFiles({
      readData: true,
      limit: 0,
    });

    if (!result) {
      return files;
    }

    for (const file of result.files) {

      files.push({
        original: file,
        response: await fetch(`data:image/jpg;base64,${file.data || ''}`),
        extension: 'jpg',
        from: 'device',
      })

    }

    return files;
  }

}
